// `scrollToAnchor` stand bis zum 18.09.2026 hier: ein nacktes `scrollIntoView`
// mit Rücksicht auf „Bewegung reduzieren". Sein letzter Aufrufer, die
// CRM-Sektion, liegt im Fenster-Modell unter einem `overflow-hidden`, und dort
// verschob der Sprung den Fenster-Körper mit (ADR-0097, Befund #2534). Wer ein
// Element ins Bild holen will, nimmt `scrollInsBild` aus
// `~/lib/scroll-im-behaelter`: erst der Behälter, dann der bewachte Rückfall.

// `scrollChatToBottom` stand bis 2026-08-25 hier daneben. Sie ist mit der
// Folge-Regel des Chats ins Paket `@dc-ai-os/chat` gezogen
// (`src/lib/chat-auto-scroll.ts`): ausserhalb des Chats hatte sie keinen
// Aufrufer.

/**
 * Liest die Systemeinstellung „Bewegung reduzieren" defensiv (jsdom kennt sie nicht).
 *
 * Einziger Aufrufer ist der Sprung-Helfer `~/lib/scroll-im-behaelter`: Er nimmt
 * die Rücksicht für alle Sprünge im dc Wingman, im Behälter wie im Rückfall.
 * Die Funktion bleibt hier stehen, weil sie keine Frage des Scroll-Behälters
 * ist, sondern eine der Umgebung.
 */
export function prefersReducedMotion(): boolean {
  return (
    typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
